import { FlexCol } from '@/components/ui/flex';
import type { FC } from 'react';
import { DiscardedItemsTab } from '../../components/RegulatoryWatchAdmin/DiscardedItemsTab';

export const AdminDiscardedItemsPage: FC = () => {
  return (
    <FlexCol gap="6" w="full" h="full" p="6" className="max-w-[1600px]">
      <DiscardedItemsTab />
    </FlexCol>
  );
};
